import { Component, EventEmitter, Input, Output } from '@angular/core'
import { Store } from '@ngrx/store'
import { Router } from '@angular/router'
import { C4PaymentMethodDetail, HttpService, SetDebitChargeInactive } from '@api/http.service'
import { catchError, first, tap } from 'rxjs/operators'
import { MatDialog } from '@angular/material/dialog'
import { DeletePaymentMethodComponent } from '../delete-payment-method/delete-payment-method.component'
import { NGXLogger } from 'ngx-logger'
import { of } from 'rxjs'
import { ErrorSnackBarComponent } from '../../../utils/components/error-snack-bar/error-snack-bar.component'
import { MatSnackBar } from '@angular/material/snack-bar'
import { CustomerInfoActions } from '../../user-profile/user-profile.actions'
import { SnackBarData } from '../../../utils/components/error-snack-bar/data'

@Component({
  selector: 'cover-payment-method-card[sessionId][paymentMethod][adrGr][personNr]',
  templateUrl: './payment-method-card.component.html',
  styleUrls: ['./payment-method-card.component.scss'],
})
export class PaymentMethodCardComponent {
  // @Input() isSelected!: boolean
  @Input() paymentMethod!: C4PaymentMethodDetail
  @Input() sessionId!: string
  @Input() adrGr!: string
  @Input() personNr!: number

  @Input() isSelected: boolean = false
  @Output() selectionEvent: EventEmitter<C4PaymentMethodDetail> = new EventEmitter<C4PaymentMethodDetail>()

  // @Output() delete: EventEmitter<void> = new EventEmitter<void>()
  // @Output() setAsDefault: EventEmitter<void> = new EventEmitter<void>()
  firstCardLine: string = ''
  secondCardLine: string = ''

  constructor(
    private readonly store: Store,
    private readonly router: Router,
    private readonly http: HttpService,
    private readonly dialog: MatDialog,
    private readonly logger: NGXLogger,
    private readonly snackbar: MatSnackBar,
  ) {}

  // delete(): void {
  //   if (this.paymentMethod.ZAHLWEG_TYP === 'S') {
  //     this.dialog
  //       .open(DeletePaymentMethodComponent)
  //       .afterClosed()
  //       .pipe(
  //         first(),
  //         tap(result => {
  //           if (result === 'true') {
  //             let requestBody: SetDebitChargeInactive = {
  //               c4pk: JSON.stringify(this.paymentMethod.C4PK).slice(1, -1) + 1,
  //               lastTyp: this.paymentMethod.LAST_TYP,
  //               sepaSatzNr: this.paymentMethod.SEPA_SATZ_NR,
  //               abbuchArt: this.paymentMethod.ABBUCH_ART,
  //               sessionId: this.sessionId,
  //               mandateReference: this.paymentMethod.MANDATS_REFERENZ,
  //               accountOwner: this.paymentMethod.INHABER,
  //               bic: this.paymentMethod.BIC,
  //               bankName: this.paymentMethod.BANKNAME,
  //               iban: this.paymentMethod.IBAN,
  //             }
  //             this.logger.debug(requestBody)
  //             this.http
  //               .setDebitChargeInactive(requestBody)
  //               .pipe(
  //                 first(),
  //                 tap(response => {
  //                   if (response.parameter.RESPONSE_OK === 1) {
  //                     this.store.dispatch(
  //                       CustomerInfoActions.paymentMethodsLoad({
  //                         payload: {
  //                           sessionId: this.sessionId,
  //                         },
  //                       }),
  //                     )
  //                   } else {
  //                     this.snackbar.openFromComponent(ErrorSnackBarComponent, {
  //                       duration: 5000,
  //                       panelClass: ['error-snack-bar'],
  //                       data: { text: response.parameter.RESPONSE_ERROR } as SnackBarData,
  //                     })
  //                   }
  //                 }),
  //                 catchError(error => {
  //                   this.snackbar.openFromComponent(ErrorSnackBarComponent, {
  //                     duration: 5000,
  //                     panelClass: ['error-snack-bar'],
  //                   })
  //                   return of(error)
  //                 }),
  //               )
  //               .subscribe()
  //           }
  //         }),
  //       )
  //       .subscribe()
  //   }
  // }
}
